import { render } from "./Enigme4.vue?vue&type=template&id=1e8d3a50"
import script from "./Enigme4.vue?vue&type=script&lang=js"
export * from "./Enigme4.vue?vue&type=script&lang=js"

import "./Enigme4.vue?vue&type=style&index=0&id=1e8d3a50&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__